import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import useCustomMedia from 'src/hooks/useCustomMedia';

import { styles } from './index.styles';

const BrandBox: FC = () => {
  const { t } = useTranslation('common');
  const { headerLogoPath, toolName } = useCustomMedia();

  return (
    <>
      <Box sx={styles.headerLogo}>
        {!!headerLogoPath && (
          <img
            alt={t('mainLogo')}
            src={headerLogoPath}
            height="100%"
            width="auto"
          />
        )}
      </Box>
      {!!toolName && <Typography variant="h4">{toolName}</Typography>}
    </>
  );
};

export default BrandBox;
